<div class="modal-top-section flex-btw" >
    <div>
        <div class="modal-title">Add Designation</div>
        <div class="modal-subtitle">Enter designation name below</div>
    </div>
     &nbsp;
    <div>
        <button mat-icon-button mat-dialog-close class="small-icon-button"> 
            <mat-icon>close</mat-icon> 
        </button>
    </div>
</div>

    <div class="custom-scroll-bar">
        <div class="top-section">
            <div class="custom-label">Name <sup style="color: red;"> * </sup></div>
            <mat-form-field class="custom-form-field" appearance="outline">
                <input type="text" name="fullname" matInput
                style="font-size: small;">
            </mat-form-field>
        </div>    
    </div>


    <div>
        <mat-dialog-actions>          
            <button mat-flat-button color="primary" class="full-width"
            cdkFocusInitial>
                <span>Save</span>
            </button> 
        </mat-dialog-actions>
    </div>